import { Component,Input, OnInit, Output,EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { Router, NavigationExtras } from '@angular/router';
import { ConfirmacionesService} from '../../../services/confirmaciones.service';
import { PagosService} from '../../../services/pagos-service.service';
import { CatalogosService } from '../../../services/catalogos.service';


@Component({
    selector: 'lista-pagos',
    templateUrl: './lista-pagos.component.html'
})

export class ListaPagoComponent implements OnInit {

    @Input() idConfirmacion: any; //[idConfirmacion]="objeto.propiedad"
    @Input() idCliente: any; //[idConfirmacion]="objeto.propiedad"

    @Input() cliente:Observable<any>;
    @Input() accion:boolean = true; // Controla si se van a desplegar la columna de "Acción"

    @Output() objetoPago = new EventEmitter<any>();
    pagosConfirmacion:Observable<any>;

    constructor(private pagosService:PagosService, public route:Router){}

    departamento:any;

    // Función de OnInit
    ngOnInit(){
        //Realiza una consulta de los pagos de una confirmacion en especial
        this.pagosConfirmacion= this.pagosService.listaPagosPorIdConfirmacion(this.idConfirmacion).snapshotChanges().map((pagosDB) =>{
            let pagoslista=[];
            var montoPagado = 0;
            //Tratado para que muestre la key del apgo
            pagosDB.forEach((pago)=>{
                const $key = pago.payload.doc.id;
                if(pagoslista.findIndex(pago => pago.$key === $key) === -1)
                {
                    let data = pago.payload.doc.data()
                    if(data.estatus == "Pagado")
                    {
                        montoPagado+= data.total;
                    }
                    pagoslista.push({$key, ...data })
                }
            })
            //this.pagosService.actualizarMontoPagado(montoPagado,this.idConfirmacion)
            return pagoslista;
        });
        this.departamento = window.localStorage.getItem("departamentoRolUsuario");
        console.log(window.localStorage.getItem("departamentoRolUsuario"))
    }
    validarPago(pago){
        this.pagosService.confirmarPago(pago.$key)
        alert("Se valido Pago")
    }

    // Emite un evento y pasa como parametro el objeto de pago cuando se le dá clici a la acción
    pasarObjetoPago(pago){
        pago.esEditar=true;
        this.objetoPago.emit(pago);
    }
    verDetalleCliente(){
        this.route.navigateByUrl('/ventas/detalle-cliente/'+this.idCliente)
    }


    descargarComprobante(link){
        if(link)
        {
            console.log(link)
            window.open(link,"_blank");
        }
        else {
            alert("No se tiene comprobante del pago")
        }

    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/lista-pagos/lista-pagos.component.ts